import React, { useState, useEffect, Fragment,useContext } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Notfound from 'pages/notfound/notfound';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import DivLayout from 'components/sales/divLayout/divLayout';
import axios from "services/interceptor/Interceptor";
import {toast} from "react-toastify";
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Config from "services/config/config";
import DocumentView from "components/sales/downloadDocView/documentView";

const ViewPostponeInstallationDetails = ({
  installationDateChangeDetail,
  viewInstallationDateChangeDetail,
  filterDropdownList = [],
  history,
  match
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [isRender, setIsRender] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [closed, setClosed] = useState(false);
  const handleModalHide = () => {
    setIsModal(false);
    window.location.reload();
  }
  const [remark, setRemark] = useState("");

  const headers = [
    'Type',
    'Former Date',
    'ChangedDate',
    'Raised By',
    'Raised On',
    'Approved By',
    'Approved On',
    'Remarks',
    'Status',
  ];

  useEffect(() => {
    (async () => {
        setIsLoading(true);
        const res=await viewInstallationDateChangeDetail(1,match.params.id);
        setIsLoading(false);
      })();
  }, []);

  const onPageChange = async (val) => {
      let filter = filterData === null ? null : filterData;
      setIsLoading(true);
      await viewInstallationDateChangeDetail(val.selected + 1,match.params.id);
      localStorage.setItem('page', val.selected + 1)
      setIsLoading(false);
  };

  const updateApproval = async (data) => {
    setActionData(data);
    if (data.action === 'accept') {
        const payload = {
            id: match.params.id,
            remarks: '',
            actionFor: 'Accept',
            status: 2
        }; 
        setIsLoading(true);
        try {
            const url = `${Config.installation.approveInstallationDateChange}`;   
            const response = await axios.patch(url, payload);
            const res = response.data?.response?.data;

            if (res === true) {
              await viewInstallationDateChangeDetail(1,match.params.id);
              setIsLoading(false);
              setIsModal(true);
              history.goBack();
            } else {
                setIsLoading(false);
                toast.error('Request not approved successfully.');
            }
        } catch (error) {
            setIsLoading(false);
            toast.error('An error occurred while approving the Request.');
        }
    } else {
        setIsModal(true);
        setIsLoading(false);
    }
  };

  const handleContinue = async () => {
    setIsModal(false);
    const payload = {
      id: match.params.id,
      approval_remarks: remark,
      actionFor: 'Reject',
      status: 3
    };
    setIsLoading(true);
    (async() => {       
      const url = `${Config.installation.approveInstallationDateChange}`;   
      const { data } = await axios.patch(url,payload);
      const res = data?.response?.data;
      if(res === true) {
         await viewInstallationDateChangeDetail(1,match.params.id);
         setIsLoading(false);
         setClosed(true);
         history.goBack();
      } else {
         setIsLoading(false);
         toast.error('Request not rejected successfully.');
      }
     })();
  };

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link to="/dashboard/update-installation-date" onClick={func} className="btn btn-transparent">
          {'Return to Request Listing'}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };
  useEffect(() => {
    const tableData = [
      "type",
      "old_date",
      "changed_date",
      "created_by",
      "created_at",
      "approved_by",
      "approved_on",
      "request_remarks",
      'status',
    ];

    if (installationDateChangeDetail && installationDateChangeDetail?.change_log && installationDateChangeDetail?.change_log?.data) {
      const data = installationDateChangeDetail?.change_log?.data?.map((element) =>
          Object.assign(
              {},
              ...tableData.map((key) => (
                  {
                   [key]: element[key],
                  })

              )
          )
      );
      data && setListData(data);
      setPageCount(Math.ceil(installationDateChangeDetail?.change_log?.total / installationDateChangeDetail?.change_log?.to));
    }
  }, [installationDateChangeDetail]);

  return isRender ? (
    <Notfound />
  ) : (
    <Layout title={'Postpone Installtion Start Date Approvals'} 
      isLoading={isLoading}
      isGoback={true}
      >
      <div className="row">
        <div className="col-md-12">
          <div className="card shadow-sm"> 
            <PanelCardWithHeading title={'Request Details'}/>
            <div className="details-listing detail_alignment">

            <DivLayout
                  heading={'Site No.'}
                  data={
                    installationDateChangeDetail?.details?.site_no
                  }
                />
            <DivLayout
              heading={'Client Name'}
              data={
                installationDateChangeDetail?.details?.client_name
              }
            />
            <DivLayout
              heading={'Site Created By'}
              data={
                installationDateChangeDetail?.details?.site_created_by
              }
            />
            <DivLayout
              heading={'Initial Installation Date'}
              data={
                installationDateChangeDetail?.details?.initial_date
              }
            />
            <DivLayout
              heading={'Current Installation Date'}
              data={
                installationDateChangeDetail?.details?.old_date
              }
            />
            <DivLayout
              heading={'Requested Installation Date'}
              data={
                installationDateChangeDetail?.details?.changed_date
              }
            />
            <DivLayout
              heading={'Raised By'}
              data={
                installationDateChangeDetail?.details?.created_by
              }
            />
            <DivLayout
              heading={'Raised On'}
              data={
                installationDateChangeDetail?.details?.created_at
              }
            />
            <DivLayout
              heading={'Approved By'}
              data={
                installationDateChangeDetail?.details?.approved_by
              }
            />
            <DivLayout
              heading={'Approved On'}
              data={
                installationDateChangeDetail?.details?.approved_on
              }
            />
            <DivLayout
              heading={'Request Remarks'}
              data={
                installationDateChangeDetail?.details?.request_remarks
              }
            />
            {installationDateChangeDetail?.details?.approval_remarks &&
              <DivLayout
                heading={`Approver's Remarks`}
                data={
                  installationDateChangeDetail?.details?.approval_remarks
                }
              />
            }
            <DivLayout
              heading={'Status'}
              data={
                installationDateChangeDetail?.details?.status
              }
            />
            {installationDateChangeDetail?.details?.attachment &&
            <DocumentView
              title={'Request Attachment'}
              attachment={installationDateChangeDetail?.details?.attachment}
            />
            }
            </div>
            	{/* 										 */}
            <PanelCardWithHeading title={'Change Logs'}/>
              <div className="card-body">
                <TableSection
                  data={listData}
                  isId={false}
                  headers={headers}
                  pageCount={pageCount}
                  onPageChange={onPageChange}
                />
              </div>
              {
                installationDateChangeDetail?.details?.status === 'Pending' && (
                <div className="d-flex justify-content-center mb-5">
                  <button className="btn btn-success mr-2" onClick={() => updateApproval({ action: 'accept', actionObj: {} })}>
                    {'Approve'}
                  </button>
                  <button className="btn btn-danger" onClick={() => updateApproval({ action: 'reject', actionObj: {} })}>
                    {'Reject'}
                  </button>
                </div>
              )}
            </div>
          </div> 
        </div> 
        <ModalPop
        title={
          actionData && actionData.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={handleModalHide}
        actionData={actionData}
      >
        {actionData && actionData.action === 'reject' ? (
          <Fragment>
            <div className="modal-body">
              <div className="text-center">
                <h5>{localization.rejectRequest}</h5>
                <div className="form-group">
                  <ConstantInput
                    label={localization.addRemark}
                    required
                    isStarRequired={true}
                    type="text"
                    fullWidth={true}
                    handleChange={(val) => {
                      setRemark(val);
                    }}
                  />
                </div>
                <Button
                  className="btn btn-primary"
                  onClick={handleContinue}
                  disabled={!remark}
                >
                  {localization.continue}{' '}
                  <img src="../images/arrow-right.png" alt="" />
                </Button>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {successIconBox('Request Approved', handleModalHide)}
          </Fragment>
        )}
      </ModalPop>
    </Layout>
  );
};

ViewPostponeInstallationDetails.propTypes = {
  
};

export default ViewPostponeInstallationDetails;
